import React, {FC} from 'react';
import {Box, Button} from '@mui/material';

type Props = {
  title: string;
  RightComponent?: FC;
};

export default function HeaderBar(props: Props) {
  const {title, RightComponent} = props;
  return (
    <Box sx={styles.titleContainer}>
      <div>
        <h1 style={styles.title}>{title}</h1>
      </div>
      {RightComponent ? (
        <RightComponent />
      ) : (
        <Button
          variant="outlined"
          onClick={() => alert('This function is not implemented yet')}>
          Upload Content
        </Button>
      )}
    </Box>
  );
}

const styles = {
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: 2,
  },
  title: {fontSize: 40},
};
